/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './nav.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/router';
import * as i3 from '@angular/common';
import * as i4 from '../../../app/nav/nav.component';
import * as i5 from '../../../app/services/window.service';
import * as i6 from '../../../app/services/auth.service';
import * as i7 from '../../../app/services/userdata.service';
const styles_NavComponent:any[] = [i0.styles];
export const RenderType_NavComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_NavComponent,
    data:{}});
function View_NavComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),7,'div',[['class',
      'logo']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),4,'a',[['routerLink','/']],[[1,'target',0],[8,'href',4]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,3).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(3,671744,(null as any),0,i2.RouterLinkWithHref,
          [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n          '])),(_l()(),
          i1.ɵeld(5,0,(null as any),(null as any),0,'img',[['alt','mydevportfol.io logo'],
              ['src','https://mydevportfol.io/img/logo_transparent.png'],['width',
                  '100']],(null as any),(null as any),(null as any),(null as any),
              (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),
          i1.ɵted(-1,(null as any),['\n      ']))],(_ck,_v) => {
    const currVal_2:any = '/';
    _ck(_v,3,0,currVal_2);
  },(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,3).target;
    const currVal_1:any = i1.ɵnov(_v,3).href;
    _ck(_v,2,0,currVal_0,currVal_1);
  });
}
function View_NavComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'button',[['class',
      'btn btn-success'],['routerLink','/build'],['style','margin-right:10px']],(null as any),
      [[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onClick()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i1.ɵdid(1,16384,(null as any),0,i2.RouterLink,
      [i2.Router,i2.ActivatedRoute,[8,(null as any)],i1.Renderer2,i1.ElementRef],{routerLink:[0,
          'routerLink']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['To Builder']))],
      (_ck,_v) => {
        const currVal_0:any = '/build';
        _ck(_v,1,0,currVal_0);
      },(null as any));
}
function View_NavComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'button',[['class',
      'btn btn-success']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.loginWithGithub()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['Sign In']))],
      (null as any),(null as any));
}
function View_NavComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),0,'img',[['alt',
      ''],['class','profile_photo'],['width','35']],[[8,'src',4]],(null as any),(null as any),
      (null as any),(null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.userData.avatar_url;
    _ck(_v,0,0,currVal_0);
  });
}
function View_NavComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),23,'div',[['class',
      'dropdown']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n            '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),7,'div',[['class','user_profile']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n              '])),(_l()(),i1.ɵeld(4,0,(null as any),(null as any),1,
          'p',[['style','margin-right:5px']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['Menu'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n              '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_NavComponent_5)),i1.ɵdid(8,
          16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n            '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n            '])),(_l()(),i1.ɵeld(11,0,(null as any),
          (null as any),11,'ul',[['class','dropdown-content']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
          ['\n              '])),(_l()(),i1.ɵted(-1,(null as any),['\n              '])),
      (_l()(),i1.ɵeld(14,0,(null as any),(null as any),3,'li',[['class','animated']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵeld(15,0,(null as any),(null as any),2,'a',[['routerLink','/myaccount']],
          [[1,'target',0],[8,'href',4]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,16).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16,671744,(null as any),0,i2.RouterLinkWithHref,
          [i2.Router,i2.ActivatedRoute,i3.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),(_l()(),i1.ɵted(-1,(null as any),['Manage Account'])),(_l()(),
          i1.ɵted(-1,(null as any),['\n              '])),(_l()(),i1.ɵeld(19,0,(null as any),
          (null as any),2,'li',[['class','animated']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i1.ɵeld(20,0,(null as any),
          (null as any),1,'a',[['href','']],(null as any),[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.logout()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['Log out'])),
      (_l()(),i1.ɵted(-1,(null as any),['\n            '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n          ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.userData;
    _ck(_v,8,0,currVal_0);
    const currVal_3:any = '/myaccount';
    _ck(_v,16,0,currVal_3);
  },(_ck,_v) => {
    const currVal_1:any = i1.ɵnov(_v,16).target;
    const currVal_2:any = i1.ɵnov(_v,16).href;
    _ck(_v,15,0,currVal_1,currVal_2);
  });
}
export function View_NavComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(1,
      0,(null as any),(null as any),25,'div',[['class','animated']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(2,278528,(null as any),
      0,i3.NgClass,[i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer],
      {klass:[0,'klass'],ngClass:[1,'ngClass']},(null as any)),i1.ɵpod(3,{'fullWidth':0,
      'smallWidth':1}),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(5,
      0,(null as any),(null as any),20,'div',[['class','navCol']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['\n\n      '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
      View_NavComponent_1)),i1.ɵdid(8,16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,
      i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),
      ['\n      \n      '])),(_l()(),i1.ɵeld(10,0,(null as any),(null as any),14,'div',
      [['class','navHolder']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_NavComponent_2)),i1.ɵdid(13,
      16384,(null as any),0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_NavComponent_3)),i1.ɵdid(17,16384,(null as any),
          0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n        \n        '])),(_l()(),i1.ɵeld(19,
          0,(null as any),(null as any),4,'div',[['class','dropdownHolder']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          (null as any),['\n          '])),(_l()(),i1.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_NavComponent_4)),i1.ɵdid(22,16384,(null as any),
          0,i3.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵted(-1,(null as any),
          ['\n      '])),(_l()(),i1.ɵted(-1,(null as any),['\n\n    '])),(_l()(),i1.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,
      _v) => {
    var _co:i4.NavComponent = _v.component;
    const currVal_0:any = 'animated';
    const currVal_1:any = _ck(_v,3,0,_co.fullWidth,!_co.fullWidth);
    _ck(_v,2,0,currVal_0,currVal_1);
    const currVal_2:any = _co.fullWidth;
    _ck(_v,8,0,currVal_2);
    const currVal_3:any = (_co.userData && (_co.page != 'build'));
    _ck(_v,13,0,currVal_3);
    const currVal_4:boolean = !_co.userData;
    _ck(_v,17,0,currVal_4);
    const currVal_5:any = _co.userData;
    _ck(_v,22,0,currVal_5);
  },(null as any));
}
export function View_NavComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-nav',([] as any[]),
      (null as any),[['window','scroll']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('window:scroll' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onWindowScroll($event)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_NavComponent_0,RenderType_NavComponent)),i1.ɵdid(1,114688,(null as any),
      0,i4.NavComponent,[i5.WindowRefService,i6.AuthService,i7.UserdataService,i2.Router],
      (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const NavComponentNgFactory:i1.ComponentFactory<i4.NavComponent> = i1.ɵccf('app-nav',
    i4.NavComponent,View_NavComponent_Host_0,{page:'page'},{nextClicked:'nextClicked'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/nav/nav.component.ngfactory.ts